// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/Services/CloudEngg/section3-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/Services/CloudEngg/cld-section4-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets//Services/CloudEngg/cld-section4-bg-part2.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#Cld-eng-sec-1,
#Cld-eng-sec-2 {
    margin: 0% 10%;
}

.head-part1 {
    font-size: 22px;
    font-weight: bold;
    margin-top: 250px;
    margin-bottom: -50px;
}

.head-part2>div>h1 {
    font-size: 80px;
    font-weight: 100;
    width: 90%;
}

.head-part2 {
    display: flex;
    justify-content: space-between;
}

.head-part2>div>img {
    width: 700px;
}

.textBolder {
    font-weight: bold;
    color: #20303F;
}

#Cld-eng-sec-2 {
    display: flex;
    justify-content: space-around;
}

#Cld-eng-sec-2>div>img {
    width: 100%;
    /* box-shadow: #1445F1 25px 25px; */
}

#Cld-eng-sec-2>:nth-child(1) {
    width: 60%;
    margin-left: 50px;
}

#Cld-eng-sec-2>div>h1 {
    width: 70%;
    color: #20303F;
    font-size: 50px;
    font-weight: 600;
}

#Cld-eng-sec-2>div>h1>span {
    color: #0096FE;
}

#Cld-eng-sec-2>div>p {
    width: 90%;
    font-size: 20px;
}

#Cld-eng-sec-3 {
    width: 80%;
    margin: auto;
}

#sec3-cont {
    width: 100%;
    justify-content: space-between;
}

#Cld-eng-sec-3>:nth-child(2) {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-position: center;
}


#Cld-eng-sec-3>div>h1 {
    text-align: center;
    font-weight: 200;
    font-size: 35px;
}

#Cld-eng-sec-3>div>h1>span {
    font-weight: 800;
    color: #2D2D2D;
}

#Cld-eng-sec-3>div>p {
    text-align: center;
    font-size: 20px;
    margin-top: -20px;
    font-weight: 400;
}

.sec3-prt2>img {
    width: 80px;
    padding: 20px 20px 0 20px;
}

.sec3-prt2 {
    width: 90%;
    height: 470px;
    background-color: #ffffff;
    border-radius: 20px;
    /* margin: 20px; */
}

#sec3-cont>div {
    /* border: 1px solid #000; */
    /* justify-content: ; */
}

#sec3-cont>div>div {
    margin-bottom: 20px;
}

.sec3-prt2>h1 {
    color: #292962;
    padding: 10px 25px;
}

.sec3-prt2>p {
    color: #6B7989;
    padding: 10px 25px;
    width: 90%;
}

#Cld-eng-sec-3>:nth-child(2) {
    display: flex;
    justify-content: space-between;
}

#Cld-eng-sec-3>:nth-child(2)>div {
    margin: 0px;
}

#Cld-eng-sec-3>:nth-child(2)>:nth-child(2) {
    margin-top: 250px;
}


#Cld-eng-sec-4 {
    margin-top: 50px;
}

#sec4-prt1 {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    height: 552px;
}

#sec4-prt1>div {
    padding-top: 130px;
    margin-left: 10%;
    width: 40%;
    /* border: 2px solid red; */
}

#sec4-prt1>div>img {
    width: 100px;
}

#sec4-prt1>div>h1 {
    font-weight: 200;
    width: 80%;
    font-size: 30px;
    line-height: 52px;
}

#sec4-prt1>div>h1>span {
    font-weight: 600;
}

#sec4-prt2 {
    margin-top: -32px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    height: 466px;
}

#sec4-prt2>div>h1 {
    padding-top: 207px;
    padding-left: 337px;
    font-size: 48px;
    font-weight: 200;
    line-height: 52px;
    width: 35%;
    color: #ffffff;
}

#sec4-prt2>div>h1>span {
    font-weight: 800;
}



#sec5-prt1 {
    margin-top: -50px;
    display: flex;
    /* justify-content: space-around; */
    gap: 50px;
    justify-content: center;
}

.sec5-tbl-commonimg {
    width: 85px;
    border-radius: 7px;
    padding: 13px;
}

.sec5-tbl-top {
    display: flex;
    /* justify-content: space-around; */
    align-items: center;
}

.table {
    background-color: #ffffff;
    border: 1.1px solid #A5DDFF;
    height: 327px;
    padding: 30px;
    border-radius: 10px;
    margin-bottom: 50px;
}

#sec5-prt1>div>div {
    width: 600px;
}

.table>div>h3 {
    font-size: 28px;
    font-weight: 500;
}

.table>div>ul>li {
    font-size: 24px;
    font-weight: 400;
    line-height: 42px;
    padding: 0px 28px;
    /* gap: 22px; */
}

#sec5-prt2>.table {
    width: 1311px;
    display: flex;
    justify-content: center;
    height: 252px;
    justify-content: center;
    align-items: center;
    /* margin-left: 21%; */
}

#sec5-prt2 {
    display: flex;
    justify-content: center;
}

#sec5-prt2>.table>hr {
    height: 200px;
}

#Cld-eng-sec-6 {
    margin: 0 14%;
}

#Cld-eng-sec-6>h1 {
    font-weight: 200;
    font-size: 48px;
    line-height: 62px;
}

#Cld-eng-sec-6>h1>span {
    font-weight: 600;
}

#sec6-prt1 {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
}

#sec6-prt1>img {
    width: 28px;
    height: 20px;
}

#sec6-prt1>p {
    font-size: 20px;
    font-style: italic;
    font-weight: 700;
}

#sec6-prt2 {
    display: flex;
    justify-content: space-between;
    width: 100%;
    gap: 50px;
}

.sec6-prt2-cont {
    height: 678px;
    width: 359px;
    background-color: #0B63E5;
    padding: 20px;
    border-radius: 10px;
}


.sec6-prt2-cont>img {
    width: 57px;
}

.sec6-prt2-cont>h3 {
    font-size: 28px;
    font-weight: 400;
    line-height: 40px;
    width: 90%;
    /* text-align: center; */
    color: #ffffff;
}

.sec6-prt2-cont>ul>li {
    font-weight: 400;
    font-size: 17px;
    color: #ffffff;
    line-height: 32px;
}

.sec6-prt2-cont>hr {
    width: 100%;
    /* height: 100px; */
}

#sec6-prt2>:nth-child(3)>h3 {
    /* background-color: black; */
    width: 100%;
}

#sec6-prt3 {
    margin-top: 200px;
    text-align: center;
}

#sec6-prt3>h1 {
    font-weight: 200;
    font-size: 48px;
    align-items: center;
}

#sec6-prt3>h1>span>img {
    width: 62px;
    border-radius: 100%;
    vertical-align: middle;
    background-color: #0B63E5;
}

#sec6-prt3>h1 span {
    font-weight: 800;
}

@media (max-width: 1601px) {
    #sec4-prt2>div {
        font-size: 30px;
    }

    #sec4-prt2>div {
        font-size: 30px;
    }
}

@media (max-width: 1450px) {
    #Cld-eng-sec-2>div {
        font-size: 30px;
    }

    .head-part2>div {
        font-size: 30px;
    }
}

@media (max-width: 1380px) {
    #sec4-prt1>div>h1 {
        font-size: 30px;
    }
}

@media (max-width: 1281px) {
    .head-part1 {
        font-size: 21px;
        margin-bottom: 1px;
        margin-top: 0px;
    }

    .head-part2>div>h1 {
        font-size: 51px;
        width: 90%;
    }

    .head-part2>div>img {
        width: 429px;
        margin-left: -80px;
        margin-top: 70px;
    }

    .textBolder {
        font-weight: bold;
        color: #20303F;
    }



    #Cld-eng-sec-2 {
        margin-top: 50px;
        display: grid;
        /* justify-content: space-around;
     */
        grid-template-columns: repeat(1, 1fr);
    }

    #Cld-eng-sec-2>div>img {
        width: 100%;
        /* box-shadow: #1445F1 25px 25px; */
    }

    #Cld-eng-sec-2>:nth-child(1) {
        width: 100%;
        margin-left: 0px;
    }

    #Cld-eng-sec-2>div>h1 {
        text-align: center;
        width: 100%;
        color: #20303F;
        font-size: 40px;
    }

    #Cld-eng-sec-2>div>p {
        width: 100%;
        text-align: center;
        font-size: 20px;
        margin-bottom: 50px;
    }

    #Cld-eng-sec-3 {
        /* margin-top: 500px; */
        margin: 200px 10% 100px 10%;
    }

    #Cld-eng-sec-3>:nth-child(2) {
        background-image: none;
    }


    .sec3-prt2 {
        box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
        width: 100%;
        margin: 0px;
    }

    #sec3-cont>div {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 20px;
    }

    #Cld-eng-sec-3>:nth-child(2)>div {
        margin: 0px;
    }


    #Cld-eng-sec-4 {
        margin-top: 0px;
        margin-bottom: 100px;
        font-size: 18px;
    }

    #sec4-prt1 {
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
        background-size: 180%;
        background-position: center;
        background-repeat: no-repeat;
    }

    #sec4-prt1>div {
        padding-top: 130px;
        margin-left: 10%;
        /* width: 40%; */
    }

    #sec4-prt1>div>img {
        width: 100px;
    }

    #sec4-prt1>div>h1 {
        font-weight: 300;
        width: 100%;
        font-size: 28px;
        line-height: 52px;
    }

    #sec4-prt1>div>h1>span {
        font-weight: 600;
    }

    #sec4-prt2 {
        margin-top: -32px;
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        height: 466px;
    }

    #sec4-prt2>div>h1 {
        padding-top: 10%;
        padding-left: 6%;
        font-size: 48px;
        font-weight: 200;
        line-height: 52px;
        width: 45%;
        color: #ffffff;
    }

    #sec4-prt2>div>h1>span {
        font-weight: 800;
    }

    #Cld-eng-sec-5 {
        margin: 0 10%;
    }


    #sec5-prt1 {
        margin-top: -50px;
        display: flex;
        gap: 20px;
        justify-content: center;
        margin: 0;
    }

    .sec5-tbl-commonimg {
        width: 45px;
        border-radius: 7px;
        padding: 13px;
    }

    .sec5-tbl-top {
        display: flex;
        justify-content: space-around;
        align-items: center;
    }

    .table {
        background-color: #ffffff;
        border: 1.1px solid #A5DDFF;
        height: 430px;
        padding: 30px;
        border-radius: 10px;
        margin-bottom: 50px;
    }

    #sec5-prt1>div>div {
        width: 80%;
    }

    .table>div>h3 {
        font-size: 17px;
        font-weight: 500;
        width: 200px;
    }

    .table>div>ul>li {
        font-size: 18px;
        font-weight: 400;
        line-height: 42px;
        padding: 0px;
        width: 100%;
        /* gap: 22px; */
    }

    #sec5-prt2>.table {
        width: 100%;
        display: flex;
        justify-content: center;
        height: 300px;
        justify-content: center;
        align-items: center;
        /* margin-left: 21%; */
    }

    #sec5-prt2 {
        display: flex;
        justify-content: center;
        margin: 0;
    }

    #sec5-prt2>.table>hr {
        height: 300px;
    }

    #Cld-eng-sec-6 {
        margin: 0 10%;
    }

    #Cld-eng-sec-6>h1 {
        font-weight: 200;
        font-size: 48px;
        line-height: 62px;
        text-align: center;
    }

    #Cld-eng-sec-6>h1>span {
        font-weight: 600;
    }

    #sec6-prt1 {
        display: none;
        justify-content: space-evenly;
        align-items: center;
    }

    #sec6-prt1>img {
        width: 28px;
        height: 20px;
    }

    #sec6-prt1>p {
        font-size: 20px;
        font-style: italic;
        font-weight: 700;
    }

    #sec6-prt2 {
        display: flex;
        justify-content: space-between;
        width: 100%;
        gap: 50px;
    }

    .sec6-prt2-cont {
        height: auto;
        min-height: 400px;
        width: 90%;
        background-color: #0B63E5;
        padding: 20px;
        border-radius: 10px;
    }


    .sec6-prt2-cont>img {
        width: 57px;
    }

    .sec6-prt2-cont>hr {
        width: 90%;
        height: 2px;
        color: #ffffff;
    }

    .sec6-prt2-cont>h3 {
        font-size: 22px;
        font-weight: 400;
        line-height: 40px;
        width: 90%;
        /* text-align: center; */
        color: #ffffff;
    }

    .sec6-prt2-cont>ul>li {
        font-weight: 400;
        font-size: 15px;
        color: #ffffff;
        /* font-family: 'Plus Jakarta Sans', sans-serif; */
        line-height: 32px;
    }

    #sec6-prt2>:nth-child(3)>h3 {
        /* background-color: black; */
        width: 100%;
    }

    #sec6-prt3 {
        margin-top: 100px;
        text-align: center;
    }

    #sec6-prt3>h1 {
        font-weight: 200;
        font-size: 35px;
        align-items: center;
    }

    #sec6-prt3>h1>span>img {
        width: 62px;
        border-radius: 100%;
        vertical-align: middle;
        background-color: #0B63E5;
    }

    #sec6-prt3>h1 span {
        font-weight: 800;
    }
}

@media (max-width: 801px) {
    #sec4-prt1>div>h1 {
        font-size: 25px;
        line-height: 1.5;
        /* border: 1px solid yellow; */
        margin-top: 0px;
    }
}


@media (max-width: 500px) {
    .head-part1 {
        font-size: 21px;
        margin-bottom: 1px;
        margin-top: 0px;
    }

    .head-part2>div>h1 {
        font-size: 41px;
        width: 100%;
    }

    .head-part2 {
        display: block;
    }



    #Cld-eng-sec-2 {
        display: grid;
        grid-template-columns: repeat(1, 1fr);
    }

    #Cld-eng-sec-2>div>br {
        display: none;
    }

    #Cld-eng-sec-2>div>img {
        width: 100%;
        /* box-shadow: #1445F1 25px 25px; */
    }

    #Cld-eng-sec-2>:nth-child(1) {
        width: 100%;
        margin-left: 0px;
    }

    #Cld-eng-sec-3>div>h1 {
        font-size: 30px;
        margin-bottom: 30px;
    }

    #Cld-eng-sec-3 {
        /* margin-top: 500px; */
        margin: 100px 10% 100px 10%;
    }

    #Cld-eng-sec-3>:nth-child(2) {
        background-image: none;
    }


    .sec3-prt2 {
        box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
        width: 100%;
        margin: 0px;
        height: auto;
    }

    .sec3-prt2>h1 {
        font-size: 20px;
    }

    .sec3-prt2>p {
        font-size: 15px;
    }

    .sec3-prt2>img {
        width: 60px;
    }


    #sec3-cont>div {
        display: grid;
        grid-template-columns: repeat(1, 1fr);
        gap: 20px;
    }

    #Cld-eng-sec-3>:nth-child(2)>div {
        margin: 0px;
    }


    #Cld-eng-sec-4 {
        margin-top: 0px;
        margin-bottom: 100px;
    }

    #sec4-prt1 {
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
        background-size: 180%;
        background-position: center;
        background-repeat: no-repeat;
        margin-top: -200px;
        /* height: 552px; */
    }

    #sec4-prt1>div {
        padding-top: 140px;
        margin-left: 10%;
        width: 70%;
    }

    #sec4-prt1>div>img {
        width: 70px;
        margin-top: 45px;
    }

    #sec4-prt1>div>h1 {
        font-weight: 300;
        /* padding-top: 50px; */
        width: 100%;
        font-size: 18px;
        line-height: 30px;
    }

    #sec4-prt1>div>h1>span {
        font-weight: 600;
    }

    #sec4-prt2 {
        margin-top: -185px;
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        height: 300px;
    }

    #sec4-prt2>div>h1 {
        padding-top: 10%;
        padding-left: 6%;
        font-size: 20px;
        font-weight: 200;
        line-height: 35px;
        width: 50%;
        color: #ffffff;
    }

    #sec4-prt2>div>h1>span {
        font-weight: 500;
    }

    #Cld-eng-sec-5 {
        margin: 0 10%;
    }


    #sec5-prt1 {
        margin-top: -50px;
        display: block;
        gap: 20px;
        justify-content: center;
        margin: 0;
    }

    .sec5-tbl-commonimg {
        width: 45px;
        border-radius: 7px;
        padding: 13px;
    }

    .sec5-tbl-top {
        display: flex;
        justify-content: space-around;
        align-items: center;
    }

    .table {
        background-color: #ffffff;
        border: 1.1px solid #A5DDFF;
        height: auto;
        padding: 30px;
        border-radius: 10px;
        margin-bottom: 50px;
    }

    #sec5-prt1>div>div {
        width: 80%;
    }

    .table>div>h3 {
        font-size: 17px;
        font-weight: 500;
        width: 200px;
    }

    .table>div>ul>li {
        font-size: 15px;
        font-weight: 400;
        line-height: 42px;
        padding: 0px;
        width: 100%;
        /* gap: 22px; */
    }

    #sec5-prt2>.table {
        width: 100%;
        display: block;
        justify-content: center;
        height: auto;
        justify-content: center;
        align-items: center;
    }

    #sec5-prt2 {
        display: flex;
        justify-content: center;
        margin: 0;
    }

    #sec5-prt2>.table>hr {
        height: 0px;
    }

    #Cld-eng-sec-6 {
        margin: 0 0%;
    }

    #Cld-eng-sec-6>h1 {
        font-weight: 200;
        font-size: 32px;
        line-height: 42px;
        text-align: center;
    }

    #Cld-eng-sec-6>h1>span {
        font-weight: 600;
    }

    #sec6-prt1 {
        display: none;
        justify-content: space-evenly;
        align-items: center;
    }

    #sec6-prt1>img {
        width: 28px;
        height: 20px;
    }

    #sec6-prt1>p {
        font-size: 20px;
        font-style: italic;
        font-weight: 700;
    }

    #sec6-prt2 {
        display: flex;
        justify-content: space-between;
        width: 100%;
        gap: 50px;
    }

    .sec6-prt2-cont {
        height: auto;
        min-height: 400px;
        width: 90%;
        background-color: #0B63E5;
        padding: 20px;
        border-radius: 10px;
    }


    .sec6-prt2-cont>img {
        width: 57px;
        /* padding-bottom: 0px; */
    }

    .sec6-prt2-cont>hr {
        width: 90%;
        height: 0px;
        color: #ffffff;
        border: 1px solid #fff;
    }

    .sec6-prt2-cont>h3 {
        font-size: 22px;
        font-weight: 400;
        line-height: 28px;
        width: 90%;
        color: #ffffff;
    }

    .sec6-prt2-cont>ul>li {
        text-align: left;
        font-weight: 400;
        font-size: 15px;
        color: #ffffff;
        line-height: 25px;
    }

    #sec6-prt2>:nth-child(3)>h3 {
        width: 100%;
    }

    #sec6-prt3 {
        margin-top: 0px;
        width: 90%;
        margin: 0 5%;
        text-align: center;
    }

    #sec6-prt3>h1 {
        font-weight: 200;
        font-size: 25px;
        align-items: center;
    }

    #sec6-prt3>h1>span>img {
        width: 42px;
        border-radius: 100%;
        vertical-align: middle;
        background-color: #0B63E5;
    }

    #sec6-prt3>h1 span {
        font-weight: 800;
    }
}

@media (max-width: 725px) {
    #sec4-prt1>div>h1 {
        font-size: 20px;
        /* border: 1px solid yellow; */
    }
}

@media (max-width: 445px) {
    #sec4-prt1>div>h1 {
        font-size: 12px;
        /* border: 1px solid yellow; */
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/Services/CloudEng.css"],"names":[],"mappings":"AAAA;;IAEI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,mCAAmC;AACvC;;AAEA;IACI,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,8BAA8B;AAClC;;AAEA;IACI,yDAAwE;IACxE,2BAA2B;AAC/B;;;AAGA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,UAAU;IACV,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,4BAA4B;IAC5B,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,iBAAiB;AACrB;;;AAGA;IACI,gBAAgB;AACpB;;AAEA;IACI,yDAA4E;IAC5E,sBAAsB;IACtB,2BAA2B;IAC3B,4BAA4B;IAC5B,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,UAAU;IACV,2BAA2B;AAC/B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,yDAAmF;IACnF,sBAAsB;IACtB,2BAA2B;IAC3B,4BAA4B;IAC5B,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;;;AAIA;IACI,iBAAiB;IACjB,aAAa;IACb,mCAAmC;IACnC,SAAS;IACT,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mCAAmC;IACnC,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;IAC3B,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,WAAW;IACX,SAAS;AACb;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,yBAAyB;IACzB,aAAa;IACb,mBAAmB;AACvB;;;AAGA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,UAAU;IACV,wBAAwB;IACxB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;IAC7B,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;QACf,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,UAAU;IACd;;IAEA;QACI,YAAY;QACZ,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;QACjB,cAAc;IAClB;;;;IAIA;QACI,gBAAgB;QAChB,aAAa;QACb;MACF;QACE,qCAAqC;IACzC;;IAEA;QACI,WAAW;QACX,mCAAmC;IACvC;;IAEA;QACI,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,cAAc;QACd,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,kBAAkB;QAClB,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,uBAAuB;QACvB,2BAA2B;IAC/B;;IAEA;QACI,sBAAsB;IAC1B;;;IAGA;QACI,2CAA2C;QAC3C,WAAW;QACX,WAAW;IACf;;IAEA;QACI,aAAa;QACb,qCAAqC;QACrC,SAAS;IACb;;IAEA;QACI,WAAW;IACf;;;IAGA;QACI,eAAe;QACf,oBAAoB;QACpB,eAAe;IACnB;;IAEA;QACI,yDAA4E;QAC5E,qBAAqB;QACrB,2BAA2B;QAC3B,4BAA4B;IAChC;;IAEA;QACI,kBAAkB;QAClB,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,gBAAgB;QAChB,WAAW;QACX,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;QACjB,yDAAmF;QACnF,sBAAsB;QACtB,2BAA2B;QAC3B,4BAA4B;QAC5B,aAAa;IACjB;;IAEA;QACI,gBAAgB;QAChB,gBAAgB;QAChB,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB,UAAU;QACV,cAAc;IAClB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;;IAGA;QACI,iBAAiB;QACjB,aAAa;QACb,SAAS;QACT,uBAAuB;QACvB,SAAS;IACb;;IAEA;QACI,WAAW;QACX,kBAAkB;QAClB,aAAa;IACjB;;IAEA;QACI,aAAa;QACb,6BAA6B;QAC7B,mBAAmB;IACvB;;IAEA;QACI,yBAAyB;QACzB,2BAA2B;QAC3B,aAAa;QACb,aAAa;QACb,mBAAmB;QACnB,mBAAmB;IACvB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,YAAY;IAChB;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB,YAAY;QACZ,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,aAAa;QACb,uBAAuB;QACvB,aAAa;QACb,uBAAuB;QACvB,mBAAmB;QACnB,sBAAsB;IAC1B;;IAEA;QACI,aAAa;QACb,uBAAuB;QACvB,SAAS;IACb;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,6BAA6B;QAC7B,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,eAAe;QACf,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,8BAA8B;QAC9B,WAAW;QACX,SAAS;IACb;;IAEA;QACI,YAAY;QACZ,iBAAiB;QACjB,UAAU;QACV,yBAAyB;QACzB,aAAa;QACb,mBAAmB;IACvB;;;IAGA;QACI,WAAW;IACf;;IAEA;QACI,UAAU;QACV,WAAW;QACX,cAAc;IAClB;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB,UAAU;QACV,wBAAwB;QACxB,cAAc;IAClB;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,cAAc;QACd,kDAAkD;QAClD,iBAAiB;IACrB;;IAEA;QACI,6BAA6B;QAC7B,WAAW;IACf;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,mBAAmB;QACnB,sBAAsB;QACtB,yBAAyB;IAC7B;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,eAAe;QACf,gBAAgB;QAChB,8BAA8B;QAC9B,eAAe;IACnB;AACJ;;;AAGA;IACI;QACI,eAAe;QACf,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,WAAW;IACf;;IAEA;QACI,cAAc;IAClB;;;;IAIA;QACI,aAAa;QACb,qCAAqC;IACzC;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,mCAAmC;IACvC;;IAEA;QACI,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,uBAAuB;QACvB,2BAA2B;IAC/B;;IAEA;QACI,sBAAsB;IAC1B;;;IAGA;QACI,2CAA2C;QAC3C,WAAW;QACX,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;;;IAGA;QACI,aAAa;QACb,qCAAqC;QACrC,SAAS;IACb;;IAEA;QACI,WAAW;IACf;;;IAGA;QACI,eAAe;QACf,oBAAoB;IACxB;;IAEA;QACI,yDAA4E;QAC5E,qBAAqB;QACrB,2BAA2B;QAC3B,4BAA4B;QAC5B,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;QAClB,gBAAgB;QAChB,UAAU;IACd;;IAEA;QACI,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;QAChB,uBAAuB;QACvB,WAAW;QACX,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;QAClB,yDAAmF;QACnF,sBAAsB;QACtB,2BAA2B;QAC3B,4BAA4B;QAC5B,aAAa;IACjB;;IAEA;QACI,gBAAgB;QAChB,gBAAgB;QAChB,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB,UAAU;QACV,cAAc;IAClB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;;IAGA;QACI,iBAAiB;QACjB,cAAc;QACd,SAAS;QACT,uBAAuB;QACvB,SAAS;IACb;;IAEA;QACI,WAAW;QACX,kBAAkB;QAClB,aAAa;IACjB;;IAEA;QACI,aAAa;QACb,6BAA6B;QAC7B,mBAAmB;IACvB;;IAEA;QACI,yBAAyB;QACzB,2BAA2B;QAC3B,YAAY;QACZ,aAAa;QACb,mBAAmB;QACnB,mBAAmB;IACvB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,YAAY;IAChB;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB,YAAY;QACZ,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,cAAc;QACd,uBAAuB;QACvB,YAAY;QACZ,uBAAuB;QACvB,mBAAmB;IACvB;;IAEA;QACI,aAAa;QACb,uBAAuB;QACvB,SAAS;IACb;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,6BAA6B;QAC7B,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,eAAe;QACf,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,8BAA8B;QAC9B,WAAW;QACX,SAAS;IACb;;IAEA;QACI,YAAY;QACZ,iBAAiB;QACjB,UAAU;QACV,yBAAyB;QACzB,aAAa;QACb,mBAAmB;IACvB;;;IAGA;QACI,WAAW;QACX,yBAAyB;IAC7B;;IAEA;QACI,UAAU;QACV,WAAW;QACX,cAAc;QACd,sBAAsB;IAC1B;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB,UAAU;QACV,cAAc;IAClB;;IAEA;QACI,gBAAgB;QAChB,gBAAgB;QAChB,eAAe;QACf,cAAc;QACd,iBAAiB;IACrB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;QACf,UAAU;QACV,YAAY;QACZ,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,mBAAmB;QACnB,sBAAsB;QACtB,yBAAyB;IAC7B;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,eAAe;QACf,8BAA8B;IAClC;AACJ;;AAEA;IACI;QACI,eAAe;QACf,8BAA8B;IAClC;AACJ","sourcesContent":["#Cld-eng-sec-1,\r\n#Cld-eng-sec-2 {\r\n    margin: 0% 10%;\r\n}\r\n\r\n.head-part1 {\r\n    font-size: 22px;\r\n    font-weight: bold;\r\n    margin-top: 250px;\r\n    margin-bottom: -50px;\r\n}\r\n\r\n.head-part2>div>h1 {\r\n    font-size: 80px;\r\n    font-weight: 100;\r\n    width: 90%;\r\n}\r\n\r\n.head-part2 {\r\n    display: flex;\r\n    justify-content: space-between;\r\n}\r\n\r\n.head-part2>div>img {\r\n    width: 700px;\r\n}\r\n\r\n.textBolder {\r\n    font-weight: bold;\r\n    color: #20303F;\r\n}\r\n\r\n#Cld-eng-sec-2 {\r\n    display: flex;\r\n    justify-content: space-around;\r\n}\r\n\r\n#Cld-eng-sec-2>div>img {\r\n    width: 100%;\r\n    /* box-shadow: #1445F1 25px 25px; */\r\n}\r\n\r\n#Cld-eng-sec-2>:nth-child(1) {\r\n    width: 60%;\r\n    margin-left: 50px;\r\n}\r\n\r\n#Cld-eng-sec-2>div>h1 {\r\n    width: 70%;\r\n    color: #20303F;\r\n    font-size: 50px;\r\n    font-weight: 600;\r\n}\r\n\r\n#Cld-eng-sec-2>div>h1>span {\r\n    color: #0096FE;\r\n}\r\n\r\n#Cld-eng-sec-2>div>p {\r\n    width: 90%;\r\n    font-size: 20px;\r\n}\r\n\r\n#Cld-eng-sec-3 {\r\n    width: 80%;\r\n    margin: auto;\r\n}\r\n\r\n#sec3-cont {\r\n    width: 100%;\r\n    justify-content: space-between;\r\n}\r\n\r\n#Cld-eng-sec-3>:nth-child(2) {\r\n    background-image: url(\"../../assets/Services/CloudEngg/section3-bg.png\");\r\n    background-position: center;\r\n}\r\n\r\n\r\n#Cld-eng-sec-3>div>h1 {\r\n    text-align: center;\r\n    font-weight: 200;\r\n    font-size: 35px;\r\n}\r\n\r\n#Cld-eng-sec-3>div>h1>span {\r\n    font-weight: 800;\r\n    color: #2D2D2D;\r\n}\r\n\r\n#Cld-eng-sec-3>div>p {\r\n    text-align: center;\r\n    font-size: 20px;\r\n    margin-top: -20px;\r\n    font-weight: 400;\r\n}\r\n\r\n.sec3-prt2>img {\r\n    width: 80px;\r\n    padding: 20px 20px 0 20px;\r\n}\r\n\r\n.sec3-prt2 {\r\n    width: 90%;\r\n    height: 470px;\r\n    background-color: #ffffff;\r\n    border-radius: 20px;\r\n    /* margin: 20px; */\r\n}\r\n\r\n#sec3-cont>div {\r\n    /* border: 1px solid #000; */\r\n    /* justify-content: ; */\r\n}\r\n\r\n#sec3-cont>div>div {\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.sec3-prt2>h1 {\r\n    color: #292962;\r\n    padding: 10px 25px;\r\n}\r\n\r\n.sec3-prt2>p {\r\n    color: #6B7989;\r\n    padding: 10px 25px;\r\n    width: 90%;\r\n}\r\n\r\n#Cld-eng-sec-3>:nth-child(2) {\r\n    display: flex;\r\n    justify-content: space-between;\r\n}\r\n\r\n#Cld-eng-sec-3>:nth-child(2)>div {\r\n    margin: 0px;\r\n}\r\n\r\n#Cld-eng-sec-3>:nth-child(2)>:nth-child(2) {\r\n    margin-top: 250px;\r\n}\r\n\r\n\r\n#Cld-eng-sec-4 {\r\n    margin-top: 50px;\r\n}\r\n\r\n#sec4-prt1 {\r\n    background-image: url(\"../../assets/Services/CloudEngg/cld-section4-bg.png\");\r\n    background-size: cover;\r\n    background-position: center;\r\n    background-repeat: no-repeat;\r\n    height: 552px;\r\n}\r\n\r\n#sec4-prt1>div {\r\n    padding-top: 130px;\r\n    margin-left: 10%;\r\n    width: 40%;\r\n    /* border: 2px solid red; */\r\n}\r\n\r\n#sec4-prt1>div>img {\r\n    width: 100px;\r\n}\r\n\r\n#sec4-prt1>div>h1 {\r\n    font-weight: 200;\r\n    width: 80%;\r\n    font-size: 30px;\r\n    line-height: 52px;\r\n}\r\n\r\n#sec4-prt1>div>h1>span {\r\n    font-weight: 600;\r\n}\r\n\r\n#sec4-prt2 {\r\n    margin-top: -32px;\r\n    background-image: url(\"../../assets//Services/CloudEngg/cld-section4-bg-part2.png\");\r\n    background-size: cover;\r\n    background-position: center;\r\n    background-repeat: no-repeat;\r\n    height: 466px;\r\n}\r\n\r\n#sec4-prt2>div>h1 {\r\n    padding-top: 207px;\r\n    padding-left: 337px;\r\n    font-size: 48px;\r\n    font-weight: 200;\r\n    line-height: 52px;\r\n    width: 35%;\r\n    color: #ffffff;\r\n}\r\n\r\n#sec4-prt2>div>h1>span {\r\n    font-weight: 800;\r\n}\r\n\r\n\r\n\r\n#sec5-prt1 {\r\n    margin-top: -50px;\r\n    display: flex;\r\n    /* justify-content: space-around; */\r\n    gap: 50px;\r\n    justify-content: center;\r\n}\r\n\r\n.sec5-tbl-commonimg {\r\n    width: 85px;\r\n    border-radius: 7px;\r\n    padding: 13px;\r\n}\r\n\r\n.sec5-tbl-top {\r\n    display: flex;\r\n    /* justify-content: space-around; */\r\n    align-items: center;\r\n}\r\n\r\n.table {\r\n    background-color: #ffffff;\r\n    border: 1.1px solid #A5DDFF;\r\n    height: 327px;\r\n    padding: 30px;\r\n    border-radius: 10px;\r\n    margin-bottom: 50px;\r\n}\r\n\r\n#sec5-prt1>div>div {\r\n    width: 600px;\r\n}\r\n\r\n.table>div>h3 {\r\n    font-size: 28px;\r\n    font-weight: 500;\r\n}\r\n\r\n.table>div>ul>li {\r\n    font-size: 24px;\r\n    font-weight: 400;\r\n    line-height: 42px;\r\n    padding: 0px 28px;\r\n    /* gap: 22px; */\r\n}\r\n\r\n#sec5-prt2>.table {\r\n    width: 1311px;\r\n    display: flex;\r\n    justify-content: center;\r\n    height: 252px;\r\n    justify-content: center;\r\n    align-items: center;\r\n    /* margin-left: 21%; */\r\n}\r\n\r\n#sec5-prt2 {\r\n    display: flex;\r\n    justify-content: center;\r\n}\r\n\r\n#sec5-prt2>.table>hr {\r\n    height: 200px;\r\n}\r\n\r\n#Cld-eng-sec-6 {\r\n    margin: 0 14%;\r\n}\r\n\r\n#Cld-eng-sec-6>h1 {\r\n    font-weight: 200;\r\n    font-size: 48px;\r\n    line-height: 62px;\r\n}\r\n\r\n#Cld-eng-sec-6>h1>span {\r\n    font-weight: 600;\r\n}\r\n\r\n#sec6-prt1 {\r\n    display: flex;\r\n    justify-content: space-evenly;\r\n    align-items: center;\r\n}\r\n\r\n#sec6-prt1>img {\r\n    width: 28px;\r\n    height: 20px;\r\n}\r\n\r\n#sec6-prt1>p {\r\n    font-size: 20px;\r\n    font-style: italic;\r\n    font-weight: 700;\r\n}\r\n\r\n#sec6-prt2 {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    width: 100%;\r\n    gap: 50px;\r\n}\r\n\r\n.sec6-prt2-cont {\r\n    height: 678px;\r\n    width: 359px;\r\n    background-color: #0B63E5;\r\n    padding: 20px;\r\n    border-radius: 10px;\r\n}\r\n\r\n\r\n.sec6-prt2-cont>img {\r\n    width: 57px;\r\n}\r\n\r\n.sec6-prt2-cont>h3 {\r\n    font-size: 28px;\r\n    font-weight: 400;\r\n    line-height: 40px;\r\n    width: 90%;\r\n    /* text-align: center; */\r\n    color: #ffffff;\r\n}\r\n\r\n.sec6-prt2-cont>ul>li {\r\n    font-weight: 400;\r\n    font-size: 17px;\r\n    color: #ffffff;\r\n    line-height: 32px;\r\n}\r\n\r\n.sec6-prt2-cont>hr {\r\n    width: 100%;\r\n    /* height: 100px; */\r\n}\r\n\r\n#sec6-prt2>:nth-child(3)>h3 {\r\n    /* background-color: black; */\r\n    width: 100%;\r\n}\r\n\r\n#sec6-prt3 {\r\n    margin-top: 200px;\r\n    text-align: center;\r\n}\r\n\r\n#sec6-prt3>h1 {\r\n    font-weight: 200;\r\n    font-size: 48px;\r\n    align-items: center;\r\n}\r\n\r\n#sec6-prt3>h1>span>img {\r\n    width: 62px;\r\n    border-radius: 100%;\r\n    vertical-align: middle;\r\n    background-color: #0B63E5;\r\n}\r\n\r\n#sec6-prt3>h1 span {\r\n    font-weight: 800;\r\n}\r\n\r\n@media (max-width: 1601px) {\r\n    #sec4-prt2>div {\r\n        font-size: 30px;\r\n    }\r\n\r\n    #sec4-prt2>div {\r\n        font-size: 30px;\r\n    }\r\n}\r\n\r\n@media (max-width: 1450px) {\r\n    #Cld-eng-sec-2>div {\r\n        font-size: 30px;\r\n    }\r\n\r\n    .head-part2>div {\r\n        font-size: 30px;\r\n    }\r\n}\r\n\r\n@media (max-width: 1380px) {\r\n    #sec4-prt1>div>h1 {\r\n        font-size: 30px;\r\n    }\r\n}\r\n\r\n@media (max-width: 1281px) {\r\n    .head-part1 {\r\n        font-size: 21px;\r\n        margin-bottom: 1px;\r\n        margin-top: 0px;\r\n    }\r\n\r\n    .head-part2>div>h1 {\r\n        font-size: 51px;\r\n        width: 90%;\r\n    }\r\n\r\n    .head-part2>div>img {\r\n        width: 429px;\r\n        margin-left: -80px;\r\n        margin-top: 70px;\r\n    }\r\n\r\n    .textBolder {\r\n        font-weight: bold;\r\n        color: #20303F;\r\n    }\r\n\r\n\r\n\r\n    #Cld-eng-sec-2 {\r\n        margin-top: 50px;\r\n        display: grid;\r\n        /* justify-content: space-around;\r\n     */\r\n        grid-template-columns: repeat(1, 1fr);\r\n    }\r\n\r\n    #Cld-eng-sec-2>div>img {\r\n        width: 100%;\r\n        /* box-shadow: #1445F1 25px 25px; */\r\n    }\r\n\r\n    #Cld-eng-sec-2>:nth-child(1) {\r\n        width: 100%;\r\n        margin-left: 0px;\r\n    }\r\n\r\n    #Cld-eng-sec-2>div>h1 {\r\n        text-align: center;\r\n        width: 100%;\r\n        color: #20303F;\r\n        font-size: 40px;\r\n    }\r\n\r\n    #Cld-eng-sec-2>div>p {\r\n        width: 100%;\r\n        text-align: center;\r\n        font-size: 20px;\r\n        margin-bottom: 50px;\r\n    }\r\n\r\n    #Cld-eng-sec-3 {\r\n        /* margin-top: 500px; */\r\n        margin: 200px 10% 100px 10%;\r\n    }\r\n\r\n    #Cld-eng-sec-3>:nth-child(2) {\r\n        background-image: none;\r\n    }\r\n\r\n\r\n    .sec3-prt2 {\r\n        box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;\r\n        width: 100%;\r\n        margin: 0px;\r\n    }\r\n\r\n    #sec3-cont>div {\r\n        display: grid;\r\n        grid-template-columns: repeat(2, 1fr);\r\n        gap: 20px;\r\n    }\r\n\r\n    #Cld-eng-sec-3>:nth-child(2)>div {\r\n        margin: 0px;\r\n    }\r\n\r\n\r\n    #Cld-eng-sec-4 {\r\n        margin-top: 0px;\r\n        margin-bottom: 100px;\r\n        font-size: 18px;\r\n    }\r\n\r\n    #sec4-prt1 {\r\n        background-image: url(\"../../assets/Services/CloudEngg/cld-section4-bg.png\");\r\n        background-size: 180%;\r\n        background-position: center;\r\n        background-repeat: no-repeat;\r\n    }\r\n\r\n    #sec4-prt1>div {\r\n        padding-top: 130px;\r\n        margin-left: 10%;\r\n        /* width: 40%; */\r\n    }\r\n\r\n    #sec4-prt1>div>img {\r\n        width: 100px;\r\n    }\r\n\r\n    #sec4-prt1>div>h1 {\r\n        font-weight: 300;\r\n        width: 100%;\r\n        font-size: 28px;\r\n        line-height: 52px;\r\n    }\r\n\r\n    #sec4-prt1>div>h1>span {\r\n        font-weight: 600;\r\n    }\r\n\r\n    #sec4-prt2 {\r\n        margin-top: -32px;\r\n        background-image: url(\"../../assets//Services/CloudEngg/cld-section4-bg-part2.png\");\r\n        background-size: cover;\r\n        background-position: center;\r\n        background-repeat: no-repeat;\r\n        height: 466px;\r\n    }\r\n\r\n    #sec4-prt2>div>h1 {\r\n        padding-top: 10%;\r\n        padding-left: 6%;\r\n        font-size: 48px;\r\n        font-weight: 200;\r\n        line-height: 52px;\r\n        width: 45%;\r\n        color: #ffffff;\r\n    }\r\n\r\n    #sec4-prt2>div>h1>span {\r\n        font-weight: 800;\r\n    }\r\n\r\n    #Cld-eng-sec-5 {\r\n        margin: 0 10%;\r\n    }\r\n\r\n\r\n    #sec5-prt1 {\r\n        margin-top: -50px;\r\n        display: flex;\r\n        gap: 20px;\r\n        justify-content: center;\r\n        margin: 0;\r\n    }\r\n\r\n    .sec5-tbl-commonimg {\r\n        width: 45px;\r\n        border-radius: 7px;\r\n        padding: 13px;\r\n    }\r\n\r\n    .sec5-tbl-top {\r\n        display: flex;\r\n        justify-content: space-around;\r\n        align-items: center;\r\n    }\r\n\r\n    .table {\r\n        background-color: #ffffff;\r\n        border: 1.1px solid #A5DDFF;\r\n        height: 430px;\r\n        padding: 30px;\r\n        border-radius: 10px;\r\n        margin-bottom: 50px;\r\n    }\r\n\r\n    #sec5-prt1>div>div {\r\n        width: 80%;\r\n    }\r\n\r\n    .table>div>h3 {\r\n        font-size: 17px;\r\n        font-weight: 500;\r\n        width: 200px;\r\n    }\r\n\r\n    .table>div>ul>li {\r\n        font-size: 18px;\r\n        font-weight: 400;\r\n        line-height: 42px;\r\n        padding: 0px;\r\n        width: 100%;\r\n        /* gap: 22px; */\r\n    }\r\n\r\n    #sec5-prt2>.table {\r\n        width: 100%;\r\n        display: flex;\r\n        justify-content: center;\r\n        height: 300px;\r\n        justify-content: center;\r\n        align-items: center;\r\n        /* margin-left: 21%; */\r\n    }\r\n\r\n    #sec5-prt2 {\r\n        display: flex;\r\n        justify-content: center;\r\n        margin: 0;\r\n    }\r\n\r\n    #sec5-prt2>.table>hr {\r\n        height: 300px;\r\n    }\r\n\r\n    #Cld-eng-sec-6 {\r\n        margin: 0 10%;\r\n    }\r\n\r\n    #Cld-eng-sec-6>h1 {\r\n        font-weight: 200;\r\n        font-size: 48px;\r\n        line-height: 62px;\r\n        text-align: center;\r\n    }\r\n\r\n    #Cld-eng-sec-6>h1>span {\r\n        font-weight: 600;\r\n    }\r\n\r\n    #sec6-prt1 {\r\n        display: none;\r\n        justify-content: space-evenly;\r\n        align-items: center;\r\n    }\r\n\r\n    #sec6-prt1>img {\r\n        width: 28px;\r\n        height: 20px;\r\n    }\r\n\r\n    #sec6-prt1>p {\r\n        font-size: 20px;\r\n        font-style: italic;\r\n        font-weight: 700;\r\n    }\r\n\r\n    #sec6-prt2 {\r\n        display: flex;\r\n        justify-content: space-between;\r\n        width: 100%;\r\n        gap: 50px;\r\n    }\r\n\r\n    .sec6-prt2-cont {\r\n        height: auto;\r\n        min-height: 400px;\r\n        width: 90%;\r\n        background-color: #0B63E5;\r\n        padding: 20px;\r\n        border-radius: 10px;\r\n    }\r\n\r\n\r\n    .sec6-prt2-cont>img {\r\n        width: 57px;\r\n    }\r\n\r\n    .sec6-prt2-cont>hr {\r\n        width: 90%;\r\n        height: 2px;\r\n        color: #ffffff;\r\n    }\r\n\r\n    .sec6-prt2-cont>h3 {\r\n        font-size: 22px;\r\n        font-weight: 400;\r\n        line-height: 40px;\r\n        width: 90%;\r\n        /* text-align: center; */\r\n        color: #ffffff;\r\n    }\r\n\r\n    .sec6-prt2-cont>ul>li {\r\n        font-weight: 400;\r\n        font-size: 15px;\r\n        color: #ffffff;\r\n        /* font-family: 'Plus Jakarta Sans', sans-serif; */\r\n        line-height: 32px;\r\n    }\r\n\r\n    #sec6-prt2>:nth-child(3)>h3 {\r\n        /* background-color: black; */\r\n        width: 100%;\r\n    }\r\n\r\n    #sec6-prt3 {\r\n        margin-top: 100px;\r\n        text-align: center;\r\n    }\r\n\r\n    #sec6-prt3>h1 {\r\n        font-weight: 200;\r\n        font-size: 35px;\r\n        align-items: center;\r\n    }\r\n\r\n    #sec6-prt3>h1>span>img {\r\n        width: 62px;\r\n        border-radius: 100%;\r\n        vertical-align: middle;\r\n        background-color: #0B63E5;\r\n    }\r\n\r\n    #sec6-prt3>h1 span {\r\n        font-weight: 800;\r\n    }\r\n}\r\n\r\n@media (max-width: 801px) {\r\n    #sec4-prt1>div>h1 {\r\n        font-size: 25px;\r\n        line-height: 1.5;\r\n        /* border: 1px solid yellow; */\r\n        margin-top: 0px;\r\n    }\r\n}\r\n\r\n\r\n@media (max-width: 500px) {\r\n    .head-part1 {\r\n        font-size: 21px;\r\n        margin-bottom: 1px;\r\n        margin-top: 0px;\r\n    }\r\n\r\n    .head-part2>div>h1 {\r\n        font-size: 41px;\r\n        width: 100%;\r\n    }\r\n\r\n    .head-part2 {\r\n        display: block;\r\n    }\r\n\r\n\r\n\r\n    #Cld-eng-sec-2 {\r\n        display: grid;\r\n        grid-template-columns: repeat(1, 1fr);\r\n    }\r\n\r\n    #Cld-eng-sec-2>div>br {\r\n        display: none;\r\n    }\r\n\r\n    #Cld-eng-sec-2>div>img {\r\n        width: 100%;\r\n        /* box-shadow: #1445F1 25px 25px; */\r\n    }\r\n\r\n    #Cld-eng-sec-2>:nth-child(1) {\r\n        width: 100%;\r\n        margin-left: 0px;\r\n    }\r\n\r\n    #Cld-eng-sec-3>div>h1 {\r\n        font-size: 30px;\r\n        margin-bottom: 30px;\r\n    }\r\n\r\n    #Cld-eng-sec-3 {\r\n        /* margin-top: 500px; */\r\n        margin: 100px 10% 100px 10%;\r\n    }\r\n\r\n    #Cld-eng-sec-3>:nth-child(2) {\r\n        background-image: none;\r\n    }\r\n\r\n\r\n    .sec3-prt2 {\r\n        box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;\r\n        width: 100%;\r\n        margin: 0px;\r\n        height: auto;\r\n    }\r\n\r\n    .sec3-prt2>h1 {\r\n        font-size: 20px;\r\n    }\r\n\r\n    .sec3-prt2>p {\r\n        font-size: 15px;\r\n    }\r\n\r\n    .sec3-prt2>img {\r\n        width: 60px;\r\n    }\r\n\r\n\r\n    #sec3-cont>div {\r\n        display: grid;\r\n        grid-template-columns: repeat(1, 1fr);\r\n        gap: 20px;\r\n    }\r\n\r\n    #Cld-eng-sec-3>:nth-child(2)>div {\r\n        margin: 0px;\r\n    }\r\n\r\n\r\n    #Cld-eng-sec-4 {\r\n        margin-top: 0px;\r\n        margin-bottom: 100px;\r\n    }\r\n\r\n    #sec4-prt1 {\r\n        background-image: url(\"../../assets/Services/CloudEngg/cld-section4-bg.png\");\r\n        background-size: 180%;\r\n        background-position: center;\r\n        background-repeat: no-repeat;\r\n        margin-top: -200px;\r\n        /* height: 552px; */\r\n    }\r\n\r\n    #sec4-prt1>div {\r\n        padding-top: 140px;\r\n        margin-left: 10%;\r\n        width: 70%;\r\n    }\r\n\r\n    #sec4-prt1>div>img {\r\n        width: 70px;\r\n        margin-top: 45px;\r\n    }\r\n\r\n    #sec4-prt1>div>h1 {\r\n        font-weight: 300;\r\n        /* padding-top: 50px; */\r\n        width: 100%;\r\n        font-size: 18px;\r\n        line-height: 30px;\r\n    }\r\n\r\n    #sec4-prt1>div>h1>span {\r\n        font-weight: 600;\r\n    }\r\n\r\n    #sec4-prt2 {\r\n        margin-top: -185px;\r\n        background-image: url(\"../../assets//Services/CloudEngg/cld-section4-bg-part2.png\");\r\n        background-size: cover;\r\n        background-position: center;\r\n        background-repeat: no-repeat;\r\n        height: 300px;\r\n    }\r\n\r\n    #sec4-prt2>div>h1 {\r\n        padding-top: 10%;\r\n        padding-left: 6%;\r\n        font-size: 20px;\r\n        font-weight: 200;\r\n        line-height: 35px;\r\n        width: 50%;\r\n        color: #ffffff;\r\n    }\r\n\r\n    #sec4-prt2>div>h1>span {\r\n        font-weight: 500;\r\n    }\r\n\r\n    #Cld-eng-sec-5 {\r\n        margin: 0 10%;\r\n    }\r\n\r\n\r\n    #sec5-prt1 {\r\n        margin-top: -50px;\r\n        display: block;\r\n        gap: 20px;\r\n        justify-content: center;\r\n        margin: 0;\r\n    }\r\n\r\n    .sec5-tbl-commonimg {\r\n        width: 45px;\r\n        border-radius: 7px;\r\n        padding: 13px;\r\n    }\r\n\r\n    .sec5-tbl-top {\r\n        display: flex;\r\n        justify-content: space-around;\r\n        align-items: center;\r\n    }\r\n\r\n    .table {\r\n        background-color: #ffffff;\r\n        border: 1.1px solid #A5DDFF;\r\n        height: auto;\r\n        padding: 30px;\r\n        border-radius: 10px;\r\n        margin-bottom: 50px;\r\n    }\r\n\r\n    #sec5-prt1>div>div {\r\n        width: 80%;\r\n    }\r\n\r\n    .table>div>h3 {\r\n        font-size: 17px;\r\n        font-weight: 500;\r\n        width: 200px;\r\n    }\r\n\r\n    .table>div>ul>li {\r\n        font-size: 15px;\r\n        font-weight: 400;\r\n        line-height: 42px;\r\n        padding: 0px;\r\n        width: 100%;\r\n        /* gap: 22px; */\r\n    }\r\n\r\n    #sec5-prt2>.table {\r\n        width: 100%;\r\n        display: block;\r\n        justify-content: center;\r\n        height: auto;\r\n        justify-content: center;\r\n        align-items: center;\r\n    }\r\n\r\n    #sec5-prt2 {\r\n        display: flex;\r\n        justify-content: center;\r\n        margin: 0;\r\n    }\r\n\r\n    #sec5-prt2>.table>hr {\r\n        height: 0px;\r\n    }\r\n\r\n    #Cld-eng-sec-6 {\r\n        margin: 0 0%;\r\n    }\r\n\r\n    #Cld-eng-sec-6>h1 {\r\n        font-weight: 200;\r\n        font-size: 32px;\r\n        line-height: 42px;\r\n        text-align: center;\r\n    }\r\n\r\n    #Cld-eng-sec-6>h1>span {\r\n        font-weight: 600;\r\n    }\r\n\r\n    #sec6-prt1 {\r\n        display: none;\r\n        justify-content: space-evenly;\r\n        align-items: center;\r\n    }\r\n\r\n    #sec6-prt1>img {\r\n        width: 28px;\r\n        height: 20px;\r\n    }\r\n\r\n    #sec6-prt1>p {\r\n        font-size: 20px;\r\n        font-style: italic;\r\n        font-weight: 700;\r\n    }\r\n\r\n    #sec6-prt2 {\r\n        display: flex;\r\n        justify-content: space-between;\r\n        width: 100%;\r\n        gap: 50px;\r\n    }\r\n\r\n    .sec6-prt2-cont {\r\n        height: auto;\r\n        min-height: 400px;\r\n        width: 90%;\r\n        background-color: #0B63E5;\r\n        padding: 20px;\r\n        border-radius: 10px;\r\n    }\r\n\r\n\r\n    .sec6-prt2-cont>img {\r\n        width: 57px;\r\n        /* padding-bottom: 0px; */\r\n    }\r\n\r\n    .sec6-prt2-cont>hr {\r\n        width: 90%;\r\n        height: 0px;\r\n        color: #ffffff;\r\n        border: 1px solid #fff;\r\n    }\r\n\r\n    .sec6-prt2-cont>h3 {\r\n        font-size: 22px;\r\n        font-weight: 400;\r\n        line-height: 28px;\r\n        width: 90%;\r\n        color: #ffffff;\r\n    }\r\n\r\n    .sec6-prt2-cont>ul>li {\r\n        text-align: left;\r\n        font-weight: 400;\r\n        font-size: 15px;\r\n        color: #ffffff;\r\n        line-height: 25px;\r\n    }\r\n\r\n    #sec6-prt2>:nth-child(3)>h3 {\r\n        width: 100%;\r\n    }\r\n\r\n    #sec6-prt3 {\r\n        margin-top: 0px;\r\n        width: 90%;\r\n        margin: 0 5%;\r\n        text-align: center;\r\n    }\r\n\r\n    #sec6-prt3>h1 {\r\n        font-weight: 200;\r\n        font-size: 25px;\r\n        align-items: center;\r\n    }\r\n\r\n    #sec6-prt3>h1>span>img {\r\n        width: 42px;\r\n        border-radius: 100%;\r\n        vertical-align: middle;\r\n        background-color: #0B63E5;\r\n    }\r\n\r\n    #sec6-prt3>h1 span {\r\n        font-weight: 800;\r\n    }\r\n}\r\n\r\n@media (max-width: 725px) {\r\n    #sec4-prt1>div>h1 {\r\n        font-size: 20px;\r\n        /* border: 1px solid yellow; */\r\n    }\r\n}\r\n\r\n@media (max-width: 445px) {\r\n    #sec4-prt1>div>h1 {\r\n        font-size: 12px;\r\n        /* border: 1px solid yellow; */\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
